import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core'

const CheckboxCustom = props => {

    const { id, label, checked, onChange, labelPlacement, style } = props;

    return (
        <div>
            <FormControlLabel
                style={style}
                id={id}
                label={label}
                labelPlacement={labelPlacement}
                control={<Checkbox color='primary' onChange={onChange} checked={checked} />}
            />
        </div>
    )
}

export default (CheckboxCustom);